// BNB
export const DEFAULT_INPUT_CURRENCY = 'ETH'
// LUCHOW
export const DEFAULT_OUTPUT_CURRENCY = '0xA5Ef74068d04ba0809B7379dD76Af5Ce34Ab7C57'
